import React from "react";
import { Modal, makeStyles } from "@material-ui/core";
import { FTLTypography } from "../FTLTypography";
import classNames from "classnames";
export const FTLModal = ({ open, children, size = "small", TypographyProps, }) => {
    const classes = useStyles({ size });
    return (React.createElement(Modal, { style: {
            zIndex: 1301,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }, open: open },
        React.createElement(FTLTypography, Object.assign({ variant: "p2" }, TypographyProps, { className: classNames(classes.paper, TypographyProps === null || TypographyProps === void 0 ? void 0 : TypographyProps.className) }), children)));
};
const useStyles = makeStyles((theme) => ({
    paper: ({ size }) => ({
        position: "absolute",
        width: size === "small" ? 320 : 1000,
        outline: "none",
        backgroundColor: theme.palette.background.paper,
        boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.08), 0px 16px 16px rgba(0, 0, 0, 0.12)",
        borderRadius: "4px",
        padding: theme.spacing(6),
    }),
}));
//# sourceMappingURL=index.js.map